/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePageContentFragment} from '@amblique/contentful/app/contentful/fragments/page-content/base-page-content.fragment';
import {AccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/accordion.fragment';
import {AccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/accordion-panel.fragment';
import {ActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/action-links.fragment';
import {CardFragment} from '@amblique/contentful/app/contentful/fragments/card/card.fragment';
import {CarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/carousel.fragment';
import {EmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/embed-panel.fragment';
import {FeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list/feature-list.fragment';
import {HeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/hero-banner.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {MediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/media-carousel.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {SectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/section-panel.fragment';
import {SplitPanelFragment} from '@amblique/contentful/app/contentful/fragments/split-panel/split-panel.fragment';
import {TeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile/teaser-tile.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullPageContentFragment = gql`
  ${AccordionFragment}
  ${AccordionPanelFragment}
  ${ActionLinksFragment}
  ${BasePageContentFragment}
  ${CardFragment}
  ${CarouselFragment}
  ${EmbedPanelFragment}
  ${FeatureListFragment}
  ${HeroBannerFragment}
  ${ImageFragment}
  ${LinkFragment}
  ${MediaCarouselFragment}
  ${RichTextBlockFragment}
  ${SectionPanelFragment}
  ${SplitPanelFragment}
  ${TeaserTileFragment}
  ${VideoFragment}

  fragment FullPageContentFragment on PageContent {
    ...BasePageContentFragment

    bottomContentBlocksCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
        ... on AccordionPanel {
          ...AccordionPanelFragment
        }
        ... on ActionLinks {
          ...ActionLinksFragment
        }
        ... on Card {
          ...CardFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on EmbedPanel {
          ...EmbedPanelFragment
        }
        ... on FeatureList {
          ...FeatureListFragment
        }
        ... on HeroBanner {
          ...HeroBannerFragment
        }
        ... on Image {
          ...ImageFragment
        }
        ... on MediaCarousel {
          ...MediaCarouselFragment
        }
        ... on TeaserTile {
          ...TeaserTileFragment
        }
      }
    }
    bottomContentBlocksCursorCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
        ... on AccordionPanel {
          ...AccordionPanelFragment
        }
        ... on ActionLinks {
          ...ActionLinksFragment
        }
        ... on Card {
          ...CardFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on EmbedPanel {
          ...EmbedPanelFragment
        }
        ... on FeatureList {
          ...FeatureListFragment
        }
        ... on HeroBanner {
          ...HeroBannerFragment
        }
        ... on Image {
          ...ImageFragment
        }
        ... on MediaCarousel {
          ...MediaCarouselFragment
        }
        ... on TeaserTile {
          ...TeaserTileFragment
        }
      }
    }
    topContentBlocksCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
        ... on ActionLinks {
          ...ActionLinksFragment
        }
        ... on Card {
          ...CardFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on EmbedPanel {
          ...EmbedPanelFragment
        }
        ... on FeatureList {
          ...FeatureListFragment
        }
        ... on HeroBanner {
          ...HeroBannerFragment
        }
        ... on Image {
          ...ImageFragment
        }
        ... on Link {
          ...LinkFragment
        }
        ... on MediaCarousel {
          ...MediaCarouselFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on SplitPanel {
          ...SplitPanelFragment
        }
        ... on Video {
          ...VideoFragment
        }
      }
    }
    topContentBlocksCursorCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
        ... on ActionLinks {
          ...ActionLinksFragment
        }
        ... on Card {
          ...CardFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on EmbedPanel {
          ...EmbedPanelFragment
        }
        ... on FeatureList {
          ...FeatureListFragment
        }
        ... on HeroBanner {
          ...HeroBannerFragment
        }
        ... on Image {
          ...ImageFragment
        }
        ... on Link {
          ...LinkFragment
        }
        ... on MediaCarousel {
          ...MediaCarouselFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on SplitPanel {
          ...SplitPanelFragment
        }
        ... on Video {
          ...VideoFragment
        }
      }
    }
  }
`;
